import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'striphtml',
    standalone: false
})

export class StripHtmlPipe implements PipeTransform {
  /**
   * Returns a version of an HTML string with the tags stripped and
   * with a set number of characters, as in a preview panel
   * @param value
   * @param characters
   */
  transform(value: string, characters: number): string {
    // DOMParser produces a document with no browsing context, so parsing
    // untrusted HTML here never fetches resources or runs event handlers
    // (unlike assigning to a live element's innerHTML).
    const doc = new DOMParser().parseFromString(value || '', 'text/html');
    const text = doc.body.textContent || '';
    if (characters) {
      return text.substr(0, characters);
    }
    return text;
  }
}
